module.exports = __webpack_public_path__ + "img/scene4-6.c343ac2d.jpg";